import { forwardRef, HTMLAttributes, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { Link } from '../Link/Link';
import { linkStylesBlackThin } from '../Link/Link.styles';
import { footerStylesDefault, IFooterStyles } from './Footer.styles';

export interface IFooterProps extends IComponent<IFooterStyles>, HTMLAttributes<HTMLElement> {
  copyrightText?: string;
  onPrivacyPolicyClick?: () => void;
  onCookiePreferencesClick?: () => void;
}

interface IFooterClassNames {
  root: string;
}

export const Footer = forwardRef((props: IFooterProps, ref: Ref<HTMLElement>) => {
  const {
    styles,
    className,
    copyrightText = `Copyright © ${new Date().getFullYear()} H2O.ai. All rights reserved.`,
    onPrivacyPolicyClick,
    onCookiePreferencesClick,
    ...elementProps
  } = props;
  const classNames = useClassNames<IFooterStyles, IFooterClassNames>('Footer', footerStylesDefault, styles, className);
  return (
    <footer {...elementProps} ref={ref} className={classNames.root} data-test={props['data-test'] || 'footer'}>
      <div>{copyrightText}</div>
      {(onPrivacyPolicyClick || onCookiePreferencesClick) && (
        <div>
          {onPrivacyPolicyClick && (
            <Link styles={linkStylesBlackThin} onClick={onPrivacyPolicyClick}>
              Privacy Policy
            </Link>
          )}
          {onPrivacyPolicyClick && onCookiePreferencesClick ? ` | ` : ''}
          {onCookiePreferencesClick && (
            <Link styles={linkStylesBlackThin} onClick={onCookiePreferencesClick}>
              Cookie Preferences
            </Link>
          )}
        </div>
      )}
    </footer>
  );
});
